import React from 'react';
import $ from 'jquery';

class VerticalNavigation extends React.Component {
  constructor() {
    super();
    this.state = {
      verticalDots: []
    };
  }

  componentDidMount() {
    this.createVerticalDots();
  }

  createVerticalDots() {
    const verticalDots = [];

    $('.article-container').each((index) => {
      verticalDots.push(<NavigationDot dotIndex={index + 1} key={index + 1} />);
    });

    this.setState({ verticalDots }, this.initVerticalDots);
  }

  initVerticalDots() {
    const $navigationItems = $('.vertical-navigation a');

    // returns true, if the one pager section scrolls over the half of the screen and is
    // visible by more than a half
    // @param {jquery element} $this - a one pager section
    function visibleByHalf($this) {
      const halfWindowHeight = $(window).height() / 2,
            currentPosition = $(window).scrollTop(),
            elementPosition = $this.offset().top, // offset coordinate relative to the document
            elementHeight = $this.height(),
        // true, if the elements start crosses the window half
            isElementScrolledOverWindowHalf = elementPosition - halfWindowHeight < currentPosition,
        // true, if the element is visible over 50%
            isElementVisibleMoreThanHalf =
          elementPosition + elementHeight - halfWindowHeight > currentPosition;

      return isElementScrolledOverWindowHalf && isElementVisibleMoreThanHalf;
    }

    function updateVerticalNavigation() {
      $('.article-container').each(function () {
        const $this = $(this),
              $activeSection = $(`.vertical-navigation a[href="#${$this.attr('id')}"]`),
              activeSectionNumber = $activeSection.data('number') - 1;

        if (visibleByHalf($this)) {
          $navigationItems.eq(activeSectionNumber).addClass('is-selected');
          $this.addClass('active');
        } else {
          $navigationItems.eq(activeSectionNumber).removeClass('is-selected');
          $this.removeClass('active');
        }
      });
    }

    $(window).on('scroll', () => updateVerticalNavigation());

    $navigationItems.on('click', function (event) {
      event.preventDefault();
      if ($(this.hash).length) {
        // smooth scroll to the section
        $('body, html').animate({ scrollTop: $(this.hash).offset().top }, 500);
      }
    });
  }

  render() {
    return (
      <nav className="vertical-navigation hidden-mobile">
        <ul>{this.state.verticalDots}</ul>
      </nav>
    );
  }
}

function NavigationDot({ dotIndex }) {
  const sectionHref = `#section-${dotIndex}`,
        $section = $(sectionHref),
        sectionTitle = $section.data('breadcrumb');

  return (
    <li>
      <a
        className={`${dotIndex === 1 ? 'is-selected' : ''}`}
        href={sectionHref}
        data-number={dotIndex}
        title={sectionTitle}
      >
        <span className="navigation-dot" />
      </a>
    </li>
  );
}

NavigationDot.propTypes = {
  dotIndex: React.PropTypes.number
};

export default VerticalNavigation;



// WEBPACK FOOTER //
// ./components/verticalNavigation.js